module.exports = __webpack_public_path__ + "img/liolio-resi.91935a82.png";